// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3unOG","right":"styles_right__FQD-f"};